import React from 'react';
import { SmartLink } from '../SmartLink';
import { CategoryChip, DateRead } from './ArticleMeta';
import type { Article } from '../../types/article';
export function ArticleCard({
  article
}: {
  article: Article;
}) {
  return <SmartLink href={`/blog/${article.slug}`} className="group flex h-full flex-col" data-id="element-91" data-mp="o4s3c6hl1qwm">
      <div className="overflow-hidden rounded-[12px]" data-id="element-92" data-mp="j5xcqiddiy1y">
        <img src={article.image} alt={article.alt} loading="lazy" className="aspect-[16/10] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-93" data-mp="j9cw3xe2yt96" />
      </div>
      <CategoryChip label={article.category} className="mt-5 self-start" data-id="element-94" data-mp="5gn7dl763a8d" />
      <h3 className="mt-3 text-[19px] font-semibold leading-[1.3] tracking-[-0.02em] text-ink transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-95" data-mp="gqyp8niyumh">
        {article.title}
      </h3>
      <p className="mt-2 line-clamp-2 text-[15px] leading-[1.55] text-ink-soft" data-id="element-96" data-mp="3mnz2i6isqtge">{article.excerpt}</p>
      <DateRead date={article.date} minutes={article.readMinutes} className="mt-auto pt-4" data-id="element-97" data-mp="d1090d5inqg" />
    </SmartLink>;
}